<template>
    <StatsBanner style="position: fixed; top: 0; z-index: 99" />

    <v-container class="landing-wrapper" fluid>
        <!-- MAIN FLEX SECTION -->
        <v-row>
            <v-col
                cols="12"
                :class="
                    $vuetify.display.smAndDown
                        ? 'd-flex justify-space-between px-2 pt-8'
                        : 'd-flex justify-space-between px-10 pt-8'
                "
            >
                <v-btn @click="$router.push('/login')">
                    {{ $t("landingPage.login") }}
                </v-btn>
                <v-btn @click="$router.push('/register')">
                    {{ $t("landingPage.register") }}
                </v-btn>
            </v-col>

            <v-col
                cols="12"
                :class="$vuetify.display.smAndDown ? 'px-0' : 'px-10'"
            >
                <v-row
                    :class="
                        $vuetify.display.smAndDown ? 'ma-0 text-center' : ''
                    "
                >
                    <v-col xs="12" sm="5" md="6" lg="6">
                        <h1
                            :class="
                                $vuetify.display.smAndDown
                                    ? 'text-h3 font-weight-bold mb-1'
                                    : 'text-h3 font-weight-bold mb-1'
                            "
                        >
                            Mekonsm<br />Fracht
                        </h1>
                        <h2
                            :style="{
                                backgroundColor: '#123666',
                                width: 'fit-content',
                                color: 'white',
                                padding: '6px 12px',
                                display: 'inline-flex',
                                alignItems: 'center',
                            }"
                            class="text-h6 font-weight-bold mt-1"
                            :class="
                                $vuetify.display.smAndDown
                                    ? 'text-h5'
                                    : 'text-h4'
                            "
                        >
                            DELIVERING THE FUTURE
                            <v-icon
                                color="white"
                                :size="$vuetify.display.smAndDown ? 36 : 48"
                                >mdi-chevron-double-right</v-icon
                            >
                        </h2>
                        <div
                            class="d-flex align-center mt-1"
                            :class="
                                $vuetify.display.smAndDown
                                    ? 'justify-center'
                                    : ''
                            "
                            style="gap: 12px"
                        >
                            <img
                                :src="`${$baseUrl}mekon_trusted_logo.png`"
                                :alt="$t('landingPage.trustedCompanyBadge')"
                                width="50"
                                height="50"
                                style="object-fit: contain"
                            />
                            <span class="font-weight-bold">
                                {{
                                    $t(
                                        "landingPage.trustedCompanyBadge"
                                    ).toUpperCase()
                                }}
                            </span>
                        </div>
                    </v-col>

                    <v-col
                        xs="12"
                        sm="7"
                        md="6"
                        lg="6"
                        class="landing-page-links justify-center d-flex flex-column text-right"
                        :class="$vuetify.display.xs ? 'text-center' : ''"
                    >
                        <LandingPageLink routerLink="/policy/about">
                            {{ $t("landingPage.aboutUs").toUpperCase() }}
                        </LandingPageLink>
                        <LandingPageLink routerLink="/prices">
                            {{ $t("landingPage.prices").toUpperCase() }}
                        </LandingPageLink>
                        <LandingPageLink routerLink="/useful-links">
                            {{ $t("landingPage.usefulLinks").toUpperCase() }}
                        </LandingPageLink>
                        <LandingPageLink routerLink="/policy/terms">
                            {{
                                $t(
                                    "landingPage.termsAndConditions"
                                ).toUpperCase()
                            }}
                        </LandingPageLink>

                        <LandingPageLink routerLink="/policy/privacy">
                            {{ $t("landingPage.privacyPolicy").toUpperCase() }}
                        </LandingPageLink>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            :class="$vuetify.display.smAndDown ? 'px-2' : 'px-10'"
            class="flex-grow-0"
        >
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img
                        :src="`${$baseUrl}card-images/card1.webp`"
                        cover
                        height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)"
                    >
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle1").toUpperCase() }}
                            </div>
                            <div
                                class="text-subtitle-2 font-weight-bold text-justify"
                            >
                                {{ $t("landingPage.cardContent1") }}
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img
                        :src="`${$baseUrl}card-images/card2.webp`"
                        cover
                        height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)"
                    >
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle2").toUpperCase() }}
                            </div>
                            <div
                                class="text-subtitle-2 font-weight-bold text-justify"
                            >
                                {{ $t("landingPage.cardContent2") }}
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img
                        :src="`${$baseUrl}card-images/card3.webp`"
                        cover
                        height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)"
                    >
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle3").toUpperCase() }}
                            </div>
                            <div
                                class="text-subtitle-2 font-weight-bold text-justify"
                            >
                                {{ $t("landingPage.cardContent3") }}
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img
                        :src="`${$baseUrl}card-images/card4.webp`"
                        cover
                        height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)"
                    >
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle4").toUpperCase() }}
                            </div>
                            <!-- use v-html on each list piece -->
                            <div>
                                <div
                                    class="text-subtitle-2 font-weight-bold text-justify"
                                    v-html="$t('landingPage.cardContent4list1')"
                                ></div>
                                <div
                                    class="text-subtitle-2 font-weight-bold text-justify"
                                    v-html="$t('landingPage.cardContent4list2')"
                                ></div>
                                <div
                                    class="text-subtitle-2 font-weight-bold text-justify"
                                    v-html="$t('landingPage.cardContent4list3')"
                                ></div>
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    <BottomBanner />
</template>

<script>
import StatsBanner from "@/components/StatsBanner.vue";
import LandingPageLink from "@/components/LandingPageLink.vue";
import BottomBanner from "@/components/BottomBanner.vue";

export default {
    components: {
        StatsBanner,
        LandingPageLink,
        BottomBanner,
    },
};
</script>

<style scoped>
.landing-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 50px 0 80px 0;
}

.landing-page-links {
    gap: 20px;
    margin-left: auto;
    width: fit-content;
}

.no-ellipsis .v-card-title {
    white-space: normal !important;
}

.landing-page-cards {
    min-height: 250px;
    border-radius: 8px;
    height: 100%;
}

.yellow-rectangle {
    display: block;
    top: 20;
    background-color: #fff005;
    width: 40px;
    height: 7px;
}

.img-overlay-content {
    position: absolute;
    inset: 0;
    gap: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 16px;
    z-index: 1;
    color: #123666;
}

@media (max-width: 960px) {
    .landing-wrapper {
        padding: 50px 12px 100px 12px;
    }
}
</style>
